export default __webpack_public_path__ + "static/media/sd-parokshaseva-banner-img.3a721fca.png";